var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["returns-restocking-messages.j2"] = require( "returns-restocking-messages.j2" );
dependencies["bopis/product-bopis-messages.j2"] = require( "bopis/product-bopis-messages.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["product/templates/product-messages.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<div class=\"js-product-message\">\n\n";
output += "\n";
if((lineno = 3, colno = 8, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["product.skuInfo.hasRestockFeeCode",runtime.contextOrFrameLookup(context, frame, "False")]))) {
output += "\n    ";
var t_1;
t_1 = (lineno = 4, colno = 27, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["product.selectedSku.sku.returnRestockInfo"]));
frame.set("restockInfo", t_1, true);
if(frame.topLevel) {
context.setVariable("restockInfo", t_1);
}
if(frame.topLevel) {
context.addExport("restockInfo", t_1);
}
output += "\n    ";
var t_2;
t_2 = (runtime.contextOrFrameLookup(context, frame, "restockInfo")?("" + "" + runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "restockInfo")),"feeCode")):runtime.contextOrFrameLookup(context, frame, "None"));
frame.set("feeCode", t_2, true);
if(frame.topLevel) {
context.setVariable("feeCode", t_2);
}
if(frame.topLevel) {
context.addExport("feeCode", t_2);
}
output += "\n    ";
var t_3;
t_3 = (lineno = 6, colno = 21, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "ga"), "ga", context, ["PAGE_TYPE","restocking fee click",""]));
frame.set("gaEvent", t_3, true);
if(frame.topLevel) {
context.setVariable("gaEvent", t_3);
}
if(frame.topLevel) {
context.addExport("gaEvent", t_3);
}
output += "\n\n    <div class=\"o-row o-extra-small--12\">\n        ";
env.getTemplate("returns-restocking-messages.j2", false, "product/templates/product-messages.j2", null, function(t_6,t_4) {
if(t_6) { cb(t_6); return; }
t_4.render(context.getVariables(), frame, function(t_7,t_5) {
if(t_7) { cb(t_7); return; }
output += t_5
output += "\n    </div>\n";
})});
}
output += "\n\n";
env.getTemplate("bopis/product-bopis-messages.j2", false, "product/templates/product-messages.j2", null, function(t_10,t_8) {
if(t_10) { cb(t_10); return; }
t_8.render(context.getVariables(), frame, function(t_11,t_9) {
if(t_11) { cb(t_11); return; }
output += t_9
output += "\n\n";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"productMessages") && runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"productMessages")),"error") && !(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "quickshop")),"hideErrorMessages") && runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"productMessages")),"error") == "SIZE_COLOR_OOS")) {
output += "\n    <div class=\"g-product-message__outer\">\n\n        <div class=\"o-row c-product-message\">\n\n            <div class=\"g-product-message c-product-message__outer\">\n\n                ";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"productMessages")),"error")) {
output += "\n\n                    <p class=\"c-product-message__info--error\" data-qa-product-msg-error>\n                    ";
output += runtime.suppressValue((lineno = 27, colno = 37, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "errorTranslation"), "errorTranslation", context, [runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"productMessages")),"error"),runtime.makeKeywordArgs({"params": [runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"skuInfo")),"secondarySlice")),"displayLabel")]})])), env.opts.autoescape);
output += "\n                    </p>\n\n                ";
;
}
output += "\n\n            </div>\n\n        </div>\n\n    </div>\n\n";
;
}
output += "\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["product/templates/product-messages.j2"] , dependencies)